import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import CardSpacer from "@saleor/components/CardSpacer";
import { ConfirmButtonTransitionState } from "@saleor/components/ConfirmButton";
import Container from "@saleor/components/Container";
import Form from "@saleor/components/Form";
import Grid from "@saleor/components/Grid";
import PageBackNavigation from "@saleor/components/PageBackNavigation";
import PageBreadcrumbNavigation from "@saleor/components/PageBreadcrumbNavigation/PageBreadcrumbNavigation";
import PageHeader from "@saleor/components/PageHeader";
import SaveButtonBar from "@saleor/components/SaveButtonBar";
import { Tab, TabContainer } from "@saleor/components/Tab";
import { SaleProductDetails_sale_products } from "@saleor/discounts/types/SaleProductDetails";
import { SaleVariantDetails_sale_productVariants } from "@saleor/discounts/types/SaleVariantDetails";
import { DiscountErrorFragment } from "@saleor/fragments/types/DiscountErrorFragment";
import { dateTimePhTimeZone } from "@saleor/utils/smop/timeZonePH";
import {
  hasNoError,
  useUpdateSalesValidation
} from "@saleor/utils/validators/sales";
import React, { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { maybe } from "../../../misc";
import { ListProps, TabListActions } from "../../../types";
import {
  DiscountStatusEnum,
  SaleType as SaleTypeEnum
} from "../../../types/globalTypes";
import { SaleDetails_sale } from "../../types/SaleDetails";
// import DiscountCategories from "../DiscountCategories";
// import DiscountCollections from "../DiscountCollections";
import DiscountDates from "../DiscountDates";
import DiscountProducts from "../DiscountProducts";
import SaleInfo from "../SaleInfo";
import { SalesKAMSDropdownProps } from "../SaleListPage";
import SalesDescription from "../SalesDescription";
import SaleSellerDropdown from "../SaleSellerDropdown";
import SalesStoreList from "../SalesStoreList";
import SaleSubsidyErrorCard from "../SaleSubsidyErrorCard";
import SaleSummary from "../SaleSummary";
import SaleType from "../SaleType";
import SaleValue from "../SaleValue";
export interface SaleDetailsPageFormData {
  description: string;
  endDate: string;
  endTime: string;
  hasEndDate: boolean;
  isAppliedToAllStores: boolean;
  name: string;
  startDate: string;
  startTime: string;
  type: SaleTypeEnum;
  value: string;
}

export enum SaleDetailsPageTab {
  categories = "categories",
  collections = "collections",
  products = "products"
}
export function saleDetailsPageTab(tab: string): SaleDetailsPageTab {
  return tab === SaleDetailsPageTab.categories
    ? SaleDetailsPageTab.categories
    : tab === SaleDetailsPageTab.collections
    ? SaleDetailsPageTab.collections
    : SaleDetailsPageTab.products;
}

// TabListActions<
//   "categoryListToolbar" | "collectionListToolbar" | "productListToolbar"
// >
export interface SaleDetailsPageProps
  extends Pick<ListProps, Exclude<keyof ListProps, "onRowClick">>,
    TabListActions<"productListToolbar">,
    SalesKAMSDropdownProps {
  activeTab: SaleDetailsPageTab;
  defaultCurrency: string;
  errors: DiscountErrorFragment[];
  sale: SaleDetails_sale;
  saveButtonBarState: ConfirmButtonTransitionState;
  products: SaleProductDetails_sale_products;
  variants: SaleVariantDetails_sale_productVariants;
  saleSubsidyErrorQuantity: number;
  saleErrorExportFileLink: string;
  onBack: () => void;
  // onCategoryAssign: () => void;
  // onCategoryUnassign: (id: string) => void;
  // onCategoryClick: (id: string) => () => void;
  // onCollectionAssign: () => void;
  // onCollectionUnassign: (id: string) => void;
  // onCollectionClick: (id: string) => () => void;
  onProductAssign: () => void;
  onProductUnassign: (id: string) => void;
  onProductClick: (id: string) => () => void;
  onStoreAssign: () => void;
  onStoreUnassign: (id: string) => void;
  onRemove: () => void;
  onSubmit: (data: SaleDetailsPageFormData) => void;
  onTabClick: (index: SaleDetailsPageTab) => void;
}

// const CategoriesTab = Tab(SaleDetailsPageTab.categories);
// const CollectionsTab = Tab(SaleDetailsPageTab.collections);
const ProductsTab = Tab(SaleDetailsPageTab.products);

const SaleDetailsPage: React.FC<SaleDetailsPageProps> = ({
  activeTab,
  defaultCurrency,
  disabled,
  errors,
  onRemove,
  onSubmit,
  onTabClick,
  pageInfo,
  sale,
  saveButtonBarState,
  products,
  variants,
  onBack,
  // onCategoryAssign,
  // onCategoryUnassign,
  // onCategoryClick,
  // onCollectionAssign,
  // onCollectionUnassign,
  // onCollectionClick,
  onNextPage,
  onPreviousPage,
  onProductAssign,
  onProductUnassign,
  onProductClick,
  onStoreAssign,
  onStoreUnassign,
  // categoryListToolbar,
  // collectionListToolbar,
  saleSubsidyErrorQuantity,
  saleErrorExportFileLink,
  productListToolbar,
  isChecked,
  selected,
  toggle,
  toggleAll,
  brand,
  brandLabel,
  kamsBrands,
  onBrandChange,
  isKAMS
}) => {
  const intl = useIntl();

  const allStores = sale?.tenants.edges.map(edge => edge.node);
  const initialForm: SaleDetailsPageFormData = {
    description: maybe(() => sale.description, ""),
    endDate: dateTimePhTimeZone(maybe(() => sale.endDate, "")).date,
    endTime: dateTimePhTimeZone(maybe(() => sale.endDate, "")).time,
    hasEndDate: maybe(() => !!sale.endDate),
    isAppliedToAllStores: !allStores?.length ? true : false,
    name: maybe(() => sale.name, ""),
    startDate: dateTimePhTimeZone(maybe(() => sale.startDate, "")).date,
    startTime: dateTimePhTimeZone(maybe(() => sale.startDate, "")).time,
    type: maybe(() => sale.type, SaleTypeEnum.PERCENTAGE),
    value: maybe(() => sale.value.toString(), "")
  };

  const initialValidatedForm = {
    description: null,
    endDate: null,
    name: null,
    value: null
  };

  const [clientErrors, setErrorValdiation] = useState(initialValidatedForm);
  const handleSubmit = event => {
    const validate = useUpdateSalesValidation(event);
    if (hasNoError(validate)) {
      setErrorValdiation(validate);
      onSubmit(event);
    } else {
      setErrorValdiation(validate);
    }
  };

  const labelButton = {
    delete: "Deactivate"
  };

  const saleStatus = sale?.status === DiscountStatusEnum.ACTIVE ? true : false;
  const salesInactive =
    sale?.status === DiscountStatusEnum.INACTIVE ? true : false;

  function getQuantity() {
    // if (sale?.type === "PERCENTAGE") {
    //   return maybe(() => products.totalCount.toString(), "...");
    // }
    return maybe(() => variants.totalCount.toString(), "...");
  }

  return (
    <Form initial={initialForm} onSubmit={handleSubmit}>
      {({ change, data, hasChanged, submit }) => {
        const breadcrumbDirectory = [
          {
            name: "Sales",
            url: "/discounts/sales"
          },
          {
            name: maybe(() => sale.name)
          }
        ];

        return (
          <Container>
            {isKAMS && (
              <SaleSellerDropdown
                brand={brand}
                brandLabel={brandLabel}
                brandChoices={kamsBrands}
                onBrandChange={onBrandChange}
              />
            )}
            <PageBreadcrumbNavigation items={breadcrumbDirectory} />
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginTop: "10px"
              }}
            >
              <PageBackNavigation onBack={onBack} />
              <PageHeader title={maybe(() => sale.name)} />
            </div>
            <Grid>
              <div>
                <SaleInfo
                  data={data}
                  disabled={saleStatus || disabled}
                  errors={errors}
                  clientErrors={clientErrors}
                  onChange={change}
                />
                <CardSpacer />
                <SaleType
                  isEdit={true}
                  data={data}
                  disabled={saleStatus || disabled}
                  onChange={change}
                />
                <CardSpacer />
                {data && data.type !== "ABSOLUTE_VALUE" ? (
                  <SaleValue
                    currencySymbol={defaultCurrency}
                    data={data}
                    disabled={saleStatus || disabled}
                    errors={errors}
                    clientErrors={clientErrors}
                    onChange={change}
                  />
                ) : (
                  ""
                )}
                <CardSpacer />
                <SalesDescription
                  data={data}
                  disabled={saleStatus || disabled}
                  errors={errors}
                  clientErrors={clientErrors}
                  onChange={change}
                />
                <CardSpacer />
                <TextField
                  disabled={true}
                  fullWidth
                  name={"isAppliedToAllStores" as keyof SaleDetailsPageFormData}
                  type="hidden"
                  value={data.isAppliedToAllStores}
                  onChange={change}
                />
                <SalesStoreList
                  stores={allStores}
                  disabled={disabled}
                  emptyText={intl.formatMessage({
                    defaultMessage: "Sale applies to all stores"
                  })}
                  title={
                    <>
                      {intl.formatMessage({
                        defaultMessage: "Store",
                        description: "sales store range"
                      })}
                      <Typography variant="caption">
                        <FormattedMessage
                          defaultMessage="Sales is limited to these stores"
                          id="SaleIsLimitedToTheseStores"
                        />
                      </Typography>
                    </>
                  }
                  onStoreAssign={onStoreAssign}
                  onStoreUnassign={onStoreUnassign}
                />
                <CardSpacer />

                <TabContainer>
                  <ProductsTab
                    isActive={activeTab === SaleDetailsPageTab.products}
                    changeTab={onTabClick}
                  >
                    <div id="productsTabBtn">
                      {intl.formatMessage(
                        {
                          defaultMessage: "Products ({quantity})",
                          description: "number of products",
                          id: "saleDetailsPageProductsQuantity"
                        },
                        {
                          quantity: getQuantity()
                        }
                      )}
                    </div>
                  </ProductsTab>
                </TabContainer>
                <CardSpacer />
                {saleSubsidyErrorQuantity > 0 && (
                  <SaleSubsidyErrorCard
                    number={saleSubsidyErrorQuantity}
                    saleErrorExportFileLink={saleErrorExportFileLink}
                  />
                )}
                <CardSpacer />
                {activeTab === SaleDetailsPageTab.products ? (
                  <DiscountProducts
                    disabled={saleStatus || disabled}
                    onNextPage={onNextPage}
                    onPreviousPage={onPreviousPage}
                    onProductAssign={onProductAssign}
                    onProductUnassign={onProductUnassign}
                    onRowClick={onProductClick}
                    pageInfo={pageInfo}
                    discountView="sales"
                    discount={sale}
                    isChecked={isChecked}
                    selected={selected}
                    toggle={toggle}
                    toggleAll={toggleAll}
                    toolbar={productListToolbar}
                    variants={maybe(() => variants.edges)}
                    products={maybe(() => products.edges)}
                  />
                ) : activeTab === SaleDetailsPageTab.collections ? (
                  <></>
                ) : (
                  ""
                )}
                <CardSpacer />
                <DiscountDates
                  data={data}
                  disabled={disabled}
                  defaultCurrency={defaultCurrency}
                  clientErrors={clientErrors}
                  errors={errors}
                  onChange={change}
                />
              </div>
              <div>
                <SaleSummary defaultCurrency={defaultCurrency} sale={sale} />
              </div>
            </Grid>
            <SaveButtonBar
              id="sales"
              disabled={disabled || !hasChanged}
              status={"DRAFT"}
              onCancel={onBack}
              onDelete={salesInactive ? null : saleStatus ? null : onRemove}
              labels={labelButton}
              onSave={submit}
              state={saveButtonBarState}
            />
          </Container>
        );
      }}
    </Form>
  );
};
SaleDetailsPage.displayName = "SaleDetailsPage";
export default SaleDetailsPage;
